export default __webpack_public_path__ + "static/media/Splash_Desktop.ed199146.gif";